import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/AnalyticsExports";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomBarChart from "../CustomComponents/CustomBarChart/CustomBarChart";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import { EntityAccess, RBAC_CODE, Role } from "../../config/app-globals.enum";
import moment from "moment";
import { getSession, getUserRBAC } from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";

export default function FleetPraisoScoreTrend(props: any) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [getRBAC_ScoreTrendCard] = React.useState(
        getUserRBAC(RBAC_CODE.SCORE_TREND_CARD_VIEW, props)
    );
    const [userData] = useState(props.userData);
    const [userSession] = useState(getSession);
    const [isApiFailed] = useState(props.isApiFailed);
    const [isApi, setIsApi] = useState();
    const [fleetPraisoScoreTrend, setFleetPraisoScoreTrend] = useState(null);
    const [minPraisoScore, setMinPraisoScore] = useState<any>(null);
    const [maxPraisoScore, setMaxPraisoScore] = useState<any>(null);
    const [avgPraisoScore, setAvgPraisoScore] = useState<any>(null);

    const [praisoScore, setPraisoScore] = useState(null);
    const [praisoScoreComputed, setPraisoScoreComputed] = useState(null);
    useEffect(() => {
        setPraisoScore(props.praisoScore);
    }, [props.praisoScore]);

    useEffect(() => {
        if (props.praisoScoreComputed) {
            setPraisoScoreComputed(props.praisoScoreComputed);
        }
    }, [props.praisoScoreComputed]);

    useEffect(() => {
        setIsApi(props.isApi);
    }, [props.isApi]);

    useEffect(() => {
        if (praisoScoreComputed) {
            if (praisoScoreComputed.minScore < 0) {
                praisoScoreComputed.minScore = 0;
            }
            if (praisoScoreComputed.maxScore < 0) {
                praisoScoreComputed.maxScore = 0;
            }
            if (praisoScoreComputed.avgScore < 0) {
                praisoScoreComputed.avgScore = 0;
            }
            setMinPraisoScore(
                Math.round((praisoScoreComputed.minScore + Number.EPSILON) * 100) / 100
            );
            setMaxPraisoScore(
                Math.round((praisoScoreComputed.maxScore + Number.EPSILON) * 100) / 100
            );
            setAvgPraisoScore(
                Math.round((praisoScoreComputed.avgScore + Number.EPSILON) * 100) / 100
            );
        }
    }, [praisoScoreComputed]);

    useEffect(() => {
        if (praisoScore && praisoScore.length) {
            let labels = [];
            let barData = [];
            let lineData = [];
            for (const [index, score] of praisoScore.entries()) {
                labels.push(moment(score.scoreDate).format("DD MMM"));
                if (index === 0 || index + 1 === praisoScore.length) {
                    lineData.push(score && score.score ? score.score : 0);
                } else {
                    lineData.push(null);
                }
                barData.push(score && score.score ? score.score : 0);
            }

            if (barData && barData.length) {
                setFleetPraisoScoreTrend({
                    loading: false,
                    fleetScore: {
                        labels: labels,
                        datasets: [
                            {
                                label:
                                    getRBAC_ScoreTrendCard &&
                                        getRBAC_ScoreTrendCard.isGroupScope ===
                                        EntityAccess.ALLOWED &&
                                        getRBAC_ScoreTrendCard.isAccessible === EntityAccess.ALLOWED
                                        ? t("FLEET_PRAISO_SCORE_TREND")
                                        : t("DRIVER_PRAISO_SCORE_TREND"),
                                backgroundColor: "rgb(46, 91, 255)",
                                barPercentage: 0.5,
                                borderSkipped: 0,
                                barThickness: 14,
                                maxBarThickness: 20,
                                minBarLength: 8,
                                data: barData,
                            },
                            {
                                label: t("TREND"),
                                backgroundColor: "rgba(46, 91, 255, 0)",
                                borderColor: "rgba(151, 151, 151, .1)",
                                lineTension: 0,
                                borderWidth: 2,
                                data: lineData,
                                type: "line",
                                spanGaps: true,
                            },
                        ],
                    },
                });
            }
        }
    }, [praisoScore]);

    React.useEffect(() => {
        if (userSession && (isApiFailed || (praisoScore && !praisoScore.length))) {
            const dateArray = [];
            const randomData = [];
            let startdate = new Date(userSession.startDate);
            const enddate = new Date(userSession.endDate);
            while (startdate <= enddate) {
                dateArray.push(moment(startdate).format("DD MMM"));
                randomData.push(Math.random() * 100);
                startdate.setDate(startdate.getDate() + 1);
            }
            setFleetPraisoScoreTrend({
                loading: false,
                fleetScore: {
                    labels: dateArray,
                    datasets: [
                        {
                            label: t("FLEET_PRAISO_SCORE_TREND"),
                            backgroundColor: "rgb(241, 242, 246)",
                            barPercentage: 0.5,
                            borderSkipped: 0,
                            barThickness: 14,
                            maxBarThickness: 20,
                            minBarLength: 8,
                            data: randomData,
                        },
                        {
                            label: t("TREND"),
                            backgroundColor: "rgba(46, 91, 255, 0)",
                            borderColor: "rgba(151, 151, 151, .1)",
                            lineTension: 0,
                            borderWidth: 2,
                            data: randomData,
                            type: "line",
                            spanGaps: true,
                        },
                    ],
                },
            });
        }
    }, [userSession, isApiFailed, praisoScore]);

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <CustomPaper square elevation={0}>
                        <CustomCard
                            elevation={0}
                            className={clsx(
                                classes.cardContentWrapper,
                                isApiFailed ? classes.fleetPerformanceDisabled : null
                            )}
                        >
                            <CustomCardContent
                                className={classes.cardContent}
                                style={{ padding: "1.5em 3em" }}
                            >
                                <CustomGrid
                                    container
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={0}
                                >
                                    <CustomGrid item>
                                        <CustomTypography
                                            component="h1"
                                            variant="h5"
                                            className={classes.title}
                                        >
                                            {getRBAC_ScoreTrendCard &&
                                                getRBAC_ScoreTrendCard.isGroupScope ===
                                                EntityAccess.ALLOWED &&
                                                getRBAC_ScoreTrendCard.isAccessible ===
                                                EntityAccess.ALLOWED
                                                ? t("FLEET_PRAISO_SCORE_TREND")
                                                : t("DRIVER_PRAISO_SCORE_TREND")}{" "}
                                        </CustomTypography>
                                    </CustomGrid>
                                    <CustomGrid item>
                                        {fleetPraisoScoreTrend &&
                                            fleetPraisoScoreTrend.loading === false && (
                                                <div className={classes.reportCardChipWrap}>
                                                    {isApiFailed ||
                                                        !praisoScore ||
                                                        !praisoScore.length ? (
                                                        <>
                                                            <CustomSkeleton
                                                                animation="wave"
                                                                width={150}
                                                                height={42}
                                                                className={classes.reportCardChipApiFailed}
                                                            />
                                                            <CustomSkeleton
                                                                animation="wave"
                                                                width={150}
                                                                height={42}
                                                                className={classes.reportCardChipApiFailed}
                                                            />
                                                            <CustomSkeleton
                                                                animation="wave"
                                                                width={150}
                                                                height={42}
                                                                className={classes.reportCardChipApiFailed}
                                                            />
                                                        </>
                                                    ) : null}
                                                    {!isApiFailed && praisoScore && praisoScore.length ? (
                                                        <>
                                                            <span className={classes.reportCardChip}>
                                                                <span className={classes.reportCardChipLabel}>
                                                                    {t("MIN_SCORE")}{" "}
                                                                </span>
                                                                <span className={classes.reportCardChipValue}>
                                                                    {minPraisoScore}
                                                                </span>
                                                            </span>
                                                            <span
                                                                className={clsx(
                                                                    classes.reportCardChip,
                                                                    classes.reportCardChipGray
                                                                )}
                                                            >
                                                                <span className={classes.reportCardChipLabel}>
                                                                    {t("AVG_SCORE")}{" "}
                                                                </span>
                                                                <span className={classes.reportCardChipValue}>
                                                                    {avgPraisoScore}
                                                                </span>
                                                            </span>
                                                            <span
                                                                className={clsx(
                                                                    classes.reportCardChip,
                                                                    classes.reportCardChipGreen
                                                                )}
                                                            >
                                                                <span className={classes.reportCardChipLabel}>
                                                                    {t("MAX_SCORE")}{" "}
                                                                </span>
                                                                <span className={classes.reportCardChipValue}>
                                                                    {maxPraisoScore}
                                                                </span>
                                                            </span>
                                                        </>
                                                    ) : null}
                                                </div>
                                            )}
                                    </CustomGrid>
                                </CustomGrid>
                                <CustomGrid container>
                                    <CustomGrid item xs={12}>
                                        {isApi ? <CustomCircularProgress /> : null}
                                        {!isApi &&
                                            fleetPraisoScoreTrend &&
                                            fleetPraisoScoreTrend.loading === false && (
                                                <CustomBarChart
                                                    className={classes.reportGraph}
                                                    data={fleetPraisoScoreTrend.fleetScore}
                                                    options={{
                                                        legend: { display: false },
                                                        scales: {
                                                            xAxes: [{ gridLines: { display: false } }],
                                                            yAxes: [
                                                                {
                                                                    ticks: { beginAtZero: true },
                                                                    gridLines: { display: false },
                                                                },
                                                            ],
                                                        },
                                                    }}
                                                    height={70}
                                                />
                                            )}
                                    </CustomGrid>
                                </CustomGrid>
                            </CustomCardContent>
                        </CustomCard>
                    </CustomPaper>
                </CustomGrid>
            </CustomGrid>
        </>
    );
}
